import { ContextApi } from 'contexts/Localization/types'
import styled from 'styled-components'
import { Path } from 'config/constants/paths'
import { ConfigMenuItemsType } from '../config/config'

const getVvsGotchiMenuConfig: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Team'),
    IconComponent: ({ isActive }) => (
      <IconImg alt={t('Team')} src={isActive ? '/images/vvsGotchi/helmet.png' : '/images/vvsGotchi/helmet_gray.png'} />
    ),
    href: Path.VVS_GOTCHI_TEAM,
    isGamified: true,
    showItemsOnMobile: false,
  },
  {
    label: t('Quest'),
    IconComponent: ({ isActive }) => (
      <IconImg alt={t('Quest')} src={isActive ? '/images/vvsGotchi/flag.png' : '/images/vvsGotchi/flag_gray.png'} />
    ),
    href: Path.VVS_GOTCHI,
    home: true,
    isGamified: true,
    showItemsOnMobile: false,
  },
]

export default getVvsGotchiMenuConfig

const IconImg = styled.img`
  max-height: 100%;
`
